import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { currency as localiseCurrency } from '../../../../../utils/localise';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../RgInteraction.module.scss';

const KnowYourLimits = ({
  closeRgPopup,
  goToRgTools,
  currency,
  totalDeposit,
  depositLast24Hours
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Play Smart, Stay Informed
      </div>
      <div>
        We’re big believers in keeping things fun and balanced.
        To help you stay on top of your game, here is a quick look at your recent deposit activity:
      </div>
      <ul className={styles.list}>
        {totalDeposit !== undefined ?
          <li>{`Your total deposits to Matchbook are ${localiseCurrency(totalDeposit, currency, { symbol: true })}`}</li>
          :
          null
        }
        {depositLast24Hours !== undefined ?
          <li>{`You have made ${depositLast24Hours} deposits in the last 24 hours`}</li>
          :
          null
        }
      </ul>
      <div>
        <span>It’s always a good idea to check that your settings still fit your lifestyle.</span>
        <br />
        <br />
        <span>Would you like to review your safety tools today?</span>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={closeRgPopup}
      >
        Not Now
      </Button>
      <Button
        sizeType="wider"
        buttonType="primary"
        onClick={goToRgTools}
        className={styles.primaryButton}
      >
        Review My Settings
      </Button>
    </div>
  </Fragment>
);


KnowYourLimits.propTypes = {
  closeRgPopup: PropTypes.func.isRequired,
  goToRgTools: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  depositLast24Hours: PropTypes.number,
  totalDeposit: PropTypes.number
};

export default KnowYourLimits;

